// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--6e5a1";
export var links = "Footer-module--links--793be";
export var linksWrapper = "Footer-module--linksWrapper--e52a2";
export var socialMedia = "Footer-module--socialMedia--4da90";
export var wrapper = "Footer-module--wrapper--93f41";